import moment from 'moment';
import fieldFormatters from '../helpers/fieldFormatter';

export function number(row) {
  return (typeof row.value === 'undefined' || row.value === null) ? 0 : row.value;
}

export function boolean(row) {
  return (typeof row.value === 'undefined' || row.value === null || !row.value) ? 'No' : 'Yes';
}

export function date(row, dateFormat) {
  return (typeof row.value === 'undefined' || row.value === null) ? '' : moment(row.value).format(dateFormat);
}

export function dateTimeWithSeconds(row, dateFormat) {
  return (typeof row.value === 'undefined' || row.value === null) ? '' : moment(row.value).format(dateFormat);
}

export const formatMap = {
  number,
  boolean,
  date,
  dateTimeWithSeconds,
};

export default function excelFieldFormatters(fieldType) {
  return formatMap[fieldType] ? formatMap[fieldType] : fieldFormatters(fieldType);
}
